var React = require('react');

function IconTablet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 4c0-2.206 1.794-4 4-4h20c2.206 0 4 1.794 4 4v24c0 2.206-1.794 4-4 4H4c-2.206 0-4-1.794-4-4V4Zm16 24c0-1.106-.894-2-2-2-1.106 0-2 .894-2 2 0 1.106.894 2 2 2 1.106 0 2-.894 2-2Zm8-24H4v20h20V4Z","fill":"currentColor"}));
}

IconTablet.defaultProps = {"fill":"none","viewBox":"0 0 28 32"};

module.exports = IconTablet;

IconTablet.default = IconTablet;
